import React, { useContext, useEffect, useState } from "react";
import { Box, IconButton, Stack, Typography, Button, Popover } from "@mui/material";
import { Images } from "../../../assets/common";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LinearBar from "../../LinearBar";
import TopListPopup from "../../TopListPopup";
import ApiService from "../../../services/api-service";
import { SocketContext } from "../../../context/socket";
import { kFormatter, truncate } from "../../../constants/function";
import { useTranslation } from "react-i18next";
import AddSikiModal from "../../AddSikiModal";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getBalance } from "../../../action/balance";
import LivestreamPayPopup from "../../LivestreamPayPopup";
import StreamingDetailPoup from "../StreamingDetailPoup";
import TipPopup from "../../TipPopup";
import notifier from "../../Notifier";
import { getErrorString } from "../../../constants/function";

export default function StreamTippers({
  title,
  goal,
  channelName,
  liveUser,
  isOwner,
  goalProgress,
  setStreamTippers,
  isJoined,
  goalDescription,
  goalAmountReceived,
  setTokenData, // Add this line

}) {

  console.log("StreamTippers component has been rendered");
  const { t } = useTranslation("common");
  const [totalTip, setTotalTip] = React.useState(0);
  const socket = useContext(SocketContext).Socket;
  const [open, setOpen] = useState(false);
  const [tippers, setTippers] = React.useState([]);
  const [openPayModel, setOpenPayModel] = React.useState(false);
  const [fundingLink, setFundLink] = React.useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [currency, setCurrecy] = React.useState("siki");
  const [newWindow, setNewWindow] = React.useState();
  const [totalTipAmount, setTotalTipAmount] = useState(0); // New state to store total tips
  const [anchorEl, setAnchorEl] = useState(null);
  const [openTipModal, setOpenTipModal] = useState(false);
  const [selectedTipUser, setSelectedTipUser] = useState(null);
  const [loadingTip, setLoadingTip] = useState(false);



  const getMoonpayLink = async (amount) => {
    if (amount >= 30 && amount <= 20000) {
      try {
        setLoading(true);
        const response = await ApiService.FUNDINGLINK({
          amount: parseInt(amount),
          tag: "time to buy some BTC",
          currency: currency,
        });
        setLoading(false);
        setFundLink(response["result"]);
        handleClose();
      } catch (error) {
        setLoading(false);
        console.error("Error getting Moonpay link:", error);
      }
    }
  };

  const getPaypalLink = async (amount) => {
    if (amount >= 4.99 && amount <= 20000) {
      try {
        setLoading(true);
        const response = await ApiService.PAYPALLINK({
          amount: amount,
        });
        setLoading(false);
        setNewWindow(response.result.links[1].href);
        handleClose();
      } catch (error) {
        setLoading(false);
        console.error("Error getting PayPal link:", error);
      }
    }
  };

  const getTopTippers = async () => {
    try {
      if (!channelName) {
        console.error("No channelName provided for top tippers");
        return;
      }
      const response = await ApiService.TOP_TIPPERS(channelName);
      setTippers(response.result);
      if (response.result.length > 0) setStreamTippers(true);
      console.log("Top tippers fetched:", response.result);
    } catch (error) {
      console.error("Error fetching top tippers:", error);
    }
  };

  const openTopTippers = () => {
    getTopTippers();
    setOpen(true);
  };

  const redirect = () => {
    window.open(
      newWindow,
      "_blank",
      "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
    );
  };

  React.useEffect(() => {
    if (channelName) {
      getTopTippers();
    }
  }, [channelName]);
  // Handle updates to total tips from the socket
  React.useEffect(() => {
    setTotalTip(goalProgress);
    if (socket) {
      socket.on("totalTips", function (data) {
        if (data.playlistId === channelName) {
          getTopTippers();
          setTotalTip(data?.goalProgress || 0); // Set percentage progress
          setTotalTipAmount((prevTotal) => prevTotal + (data.tipAmount || 0)); // Add new tip to totalTipAmount
  
          // Update goalAmountReceived in the parent component state (tokenData)
          setTokenData((prevTokenData) => ({
            ...prevTokenData,
            goal: {
              ...prevTokenData.goal,
    goalAmountReceived: (prevTokenData.goal.goalAmountReceived || 0) + (data.tipAmount || 0),
            },
          }));

        }
      });
    }

    return () => {
      if (socket) {
        socket.off("totalTips");
      }
      setTippers([]); // Clean up
    };
  }, [socket, channelName, setTokenData]); // Add setTokenData to dependencies
  
  React.useEffect(() => {
    if (newWindow) {
      console.log("Opening new window for payment:", newWindow);
      redirect();
    }
  }, [newWindow]);

  const handleOpen = () => {
    console.log("Opening payment modal");
    setOpenPayModel(true);
  };

  const handleClose = () => {
    console.log("Closing payment modal");
    setOpenPayModel(false);
  };

  React.useEffect(() => {
    getTopTippers();
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
    handleClose();
  };

  const popoverOpen = Boolean(anchorEl); // Renamed open to popoverOpen to avoid conflicts
  const id = open ? "goal-description-popover" : undefined;

  const handleTipToViewer = (user) => {
    console.log("=== handleTipToViewer called ===");
    console.log("User object:", user);
    console.log("User._id:", user?._id);
    console.log("User.fullName:", user?.fullName);
    setSelectedTipUser(user);
    setOpenTipModal(true);
    console.log("openTipModal set to true");
  };

  const handleCloseTipModal = () => {
    console.log("Closing tip modal");
    setOpenTipModal(false);
    setSelectedTipUser(null);
  };

  const handleTipSuccess = async (amount, id, type, currency) => {
    if (amount) {
      setOpenTipModal(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: "livestreamArtist",
          currency: currency,
        };
        setLoadingTip(true);
        const response = await ApiService.TIP_PLAYLIST(payload);
        setLoadingTip(false);
        notifier.success(response["result"]);
        console.log("Tip sent successfully, refreshing balance");
        await dispatch(getBalance());
        getTopTippers(); // Refresh tippers list
      } catch (error) {
        setLoadingTip(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTipModal(false);
    }
  };



  return (
    <Box
    id="_streamTippers"
    sx={{
      padding: goal || tippers.length > 0 ? "16px" : 0,
      zIndex: 30, 
      backgroundColor: "rgba(0, 0, 0, 0.4)", // Semi-transparent white background
      WebkitBackdropFilter: "blur(10px)", // Safari prefix
      backdropFilter: "blur(10px)", // Frosted glass effect
      border: "1px solid rgba(9, 9, 9, 0.3)", // Light border to enhance glass effect
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", 
      width: "40%",
      maxWidth: "calc(100% - 20px)", 
      margin: "auto", 
      position: "fixed",
      bottom: "87px", 
      left: 0, 
      right: 0,
      borderRadius: "10px", 
      transition: "all 0.3s ease-out",
      }}
    >
      <Stack
        direction="row"
        justifyContent={!title || !goal ? "end" : "space-between"}
      >
        {!title || !goal ? null : (
          <Stack sx={{ flexGrow: "2", maxWidth: "70%" }} spacing={1}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
            <Stack direction="row" spacing={2} alignItems="center">
                <Typography title={title}>{truncate(title, 30)}</Typography>
                     {/* Icon button to open the Popover on click */}
            <IconButton
              aria-describedby={id}
              onClick={handleClick}
              title={goalDescription ? goalDescription : ""}
            >
              <InfoOutlinedIcon sx={{ color: "#999999", fontSize: "13px" }} />
            </IconButton>

            {/* Popover to show the goalDescription when the icon is clicked */}
            <Popover
              id={id}
              open={popoverOpen} // Using the renamed popoverOpen here
              anchorEl={anchorEl}
              onClose={handlePopoverClose} // Close popover and call the existing handleClose
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <Typography sx={{ p: 2 }}>{goalDescription}</Typography>
            </Popover>
          </Stack>
            <Stack direction="row" spacing={2} alignItems="center">
                <img
                  style={{ width: "16px", height: "16px" }}
                  src={Images.coin}
                  alt=""
                />
                <Typography className="fs-14" title={goal}>
                {new Intl.NumberFormat('en-US').format(goal)}
              </Typography>
            </Stack>
          </Stack>
            <LinearBar value={totalTip} color={"#2CF488"} />
            <Typography className="fade-text-60 fs-12">
           {goalAmountReceived} SIKI {/* Display actual total tips */}

            </Typography>
        </Stack>
        )}
        {tippers.length === 0 ? null : (
          <Stack spacing={1} sx={{ alignItems: "center", flexGrow: "3" }}>
            <Typography className="fs-14">{t("stream.text2")}</Typography>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              onClick={() => openTopTippers()}
              className="_cp"
            >
              <Stack direction="row">
                {tippers &&
                  tippers
                    .slice(0, 3)
                    .map((m, index) => (
                      <img
                        key={index}
                        className={"w24 h24 faded-round-border -mr-9"}
                        src={m?.profilePic?.filePath || Images.default_user}
                        alt=""
                      />
                ))}
              </Stack>
              <Typography className="fs-14 fw-b">
                {tippers.length} {t("stream.text3")}
              </Typography>
            </Stack>
          </Stack>
        )}
  
        {/* Buy Siki Tokens Button */}
        <Stack justifyContent="center" sx={{ padding: 0, marginLeft: "50px", }}>
    <Button
      title={t("nftDetail.nftRow.button4")}
      sx={{ height: "30px !important", fontWeight: "bold", marginLeft: "50px" }}
      onClick={handleOpen}
      variant="contained"
      color="primary"
    >
            {t("buySikiTokens")}
          </Button>
        </Stack>
      </Stack>
      {open ? (
        <TopListPopup
          isLiveUser={true}
          isUsers={true}
          onTipPoupOpen={handleTipToViewer}
          title={`${t("topListPopup.title4")} (${tippers.length})`}
          open={open}
          handleClose={() => setOpen(false)}
          isTip={true}
          isArray={true}
          data={tippers}
        />
      ) : null}
      {/* <AddSikiModal open={openPayModel} handleClose={handleClose} /> */}
      <LivestreamPayPopup
        open={openPayModel}
        handleClose={handleClose}
        handleSubmit={(amount, type) => {
          if (type == "moonPay") {
            getMoonpayLink(amount);
          } else {
            getPaypalLink(amount);
          }
        }}
        loading={loading}
      />
  
      {/* Moonpay or Payment Iframe */}
      {fundingLink && (
        <Box className="__moonpay" sx={{ zIndex: "2" }}>
          <CloseOutlinedIcon
            className="_cp"
            color="secondary"
            onClick={() => {
              setFundLink(null);
              setTimeout(() => {
                dispatch(getBalance());
              }, 2000);
            }}
          />
          <iframe style={{ height: "100%" }} allow="accelerometer; autoplay; camera; gyroscope; payment" src={fundingLink}>
            <p>Your browser does not support iframes.</p>
          </iframe>
        </Box>
      )}

      {/* Tip Popup for Viewers */}
      {openTipModal && selectedTipUser ? (
        <>
          {console.log("=== Rendering TipPopup ===")}
          {console.log("openTipModal:", openTipModal)}
          {console.log("selectedTipUser:", selectedTipUser)}
          {console.log("selectedTipUser.fullName:", selectedTipUser.fullName)}
          {console.log("selectedTipUser._id:", selectedTipUser._id)}
          <TipPopup
            artist={selectedTipUser.fullName}
            id={selectedTipUser._id}
            open={openTipModal}
            isArtist={true}
            isPlaylist={false}
            handleClose={handleTipSuccess}
          />
        </>
      ) : (
        console.log("=== TipPopup NOT rendering ===", { openTipModal, selectedTipUser })
      )}

      {/* Loading indicator for tip */}
      {loadingTip && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
          }}
        >
          <Typography color="white">{t("loader.message12")}</Typography>
        </Box>
      )}
    </Box>
  );
}